import React from "react";

const StatCard = ({ label, value }) => (
  <div className="stat-card">
    <div className="stat-number">{value}</div>
    <div className="stat-label">{label}</div>
  </div>
);

export default StatCard;
